export { useLegalConsentPageAnalytics } from "./use-legal-consent-page-analytics";
export { useSubmitUserConsentWithFlags } from "./use-submit-user-consent-with-flags";
